import { render } from "./TwitterPoll.vue?vue&type=template&id=c705979e"
import script from "./TwitterPoll.vue?vue&type=script&lang=js"
export * from "./TwitterPoll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__